// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__38Y0O","title":"FrontImage_title__d3fK-"};